import { render, staticRenderFns } from "./FollowUPLogotype.vue?vue&type=template&id=34e91540&scoped=true&"
import script from "./FollowUPLogotype.vue?vue&type=script&lang=js&"
export * from "./FollowUPLogotype.vue?vue&type=script&lang=js&"
import style0 from "./FollowUPLogotype.vue?vue&type=style&index=0&id=34e91540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e91540",
  null
  
)

export default component.exports